import { useEffect, useRef, useState } from "react"

const MobileHomeImageSwitcher = () => {
  const targetRef = useRef(null)
  const [isScrollingPaused, setIsScrollingPaused] = useState(false)
  const [hasSwitched, setHasSwitched] = useState(false)
  const images = [
    "/images/mobile-home-image-switcher-1.webp",
    "/images/mobile-home-image-switcher-2.webp",
  ]
  const [currentImageIndex, setCurrentImageIndex] = useState(0)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isScrollingPaused && !hasSwitched) {
            pauseScrolling()
            switchImage()
          }
        })
      },
      { threshold: 0.5 }
    )

    if (targetRef.current) {
      observer.observe(targetRef.current)
    }

    return () => {
      if (targetRef.current) {
        observer.unobserve(targetRef.current)
      }
    }
  }, [isScrollingPaused, hasSwitched])

  const pauseScrolling = () => {
    setIsScrollingPaused(true)
    window.addEventListener("wheel", preventScroll, { passive: false })
    window.addEventListener("touchmove", preventScroll, { passive: false })
  }

  const resumeScrolling = () => {
    setIsScrollingPaused(false)
    window.removeEventListener("wheel", preventScroll)
    window.removeEventListener("touchmove", preventScroll)
  }

  const preventScroll = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const switchImage = () => {
    setTimeout(() => {
      setCurrentImageIndex(1)
      setHasSwitched(true)
      setTimeout(resumeScrolling, 500) // 等待2秒后恢复滚动
    }, 1000) // 等待2秒切换图片
  }

  return (
    <div
      ref={targetRef}
      className="relative mx-auto mb-[64px] w-[1360px] max-w-full overflow-hidden lg_hidden"
    >
      <img
        className="duration-1000 w-full opacity-0 transition-opacity ease-in-out"
        style={{ opacity: currentImageIndex === 0 ? 1 : 0 }}
        src={images[currentImageIndex]}
      />
      <img
        src={images[1]}
        className={`duration-1000 absolute left-0 top-0 h-full w-full transition-opacity ease-in-out ${
          currentImageIndex === 1 ? "opacity-100" : "opacity-0"
        }`}
      />
      <div className="absolute top-[48px] mx-[14px] w-full">
        <h2 className="text-[18px] font-[700] leading-[26px] text-title">
          Treat hummingbirds in summer,
        </h2>
        <p
          className={`mb-[16px] text-[18px] font-[700] leading-[26px] text-[#EE6C4D] ${
            currentImageIndex === 1 ? "opacity-100" : "opacity-0"
          }`}
        >
          feed locals as winter whispers.
        </p>
        <p
          className={`inline-block rounded-[12px] bg-[#A7C957] px-[16px] text-[14px] leading-[24px] text-white ${
            currentImageIndex === 1 ? "opacity-100" : "opacity-0"
          }`}
        >
          Replaceable feeder.
        </p>
      </div>
    </div>
  )
}

export default MobileHomeImageSwitcher
